export type IPageParams = {
    accountUrn: string;
    projectUrn: string;
    nodeId?: string;
    urn?: string;
    fileId?: string;
    tool?: IPageTool;
};

export enum IPageTool {
    ISSUES = "issues",
}
